<template>
   <QCard class="graph-card">
      <QCardSection class="bg-primary q-pa-sm">
         <div class="text-h6 text-white">ezbot vs Default Conversion Rates</div>
      </QCardSection>
      <QCardSection>
         <div id="optimized-vs-default-graph-controls">
            <QToggle
               v-model="showConfidenceIntervals"
               size="sm"
               :val="showConfidenceIntervals"
               label="Show 99% Confidence Intervals"
            />
         </div>
         <OptimizedVsDefaultGraph
            :show-confidence-intervals="showConfidenceIntervals"
            :loading="loading"
            :data="
               props.data ?? {
                  dt: [],
                  default_conversion_rate: [],
                  default_lb: [],
                  default_ub: [],
                  ezbot_conversion_rate: [],
                  ezbot_lb: [],
                  ezbot_ub: [],
               }
            "
         />
      </QCardSection>
   </QCard>
</template>

<script setup lang="ts">
import { ref, defineProps, PropType } from "vue"
import { QCard, QCardSection, QToggle } from "quasar"
import OptimizedVsDefaultGraph from "./OptimizedVsDefaultGraph.vue"
import { OptVDefaultGraph } from "@/types"

const props = defineProps({
   loading: {
      type: Boolean,
      default: false,
   },
   data: {
      type: Object as PropType<OptVDefaultGraph>,
      default: () => ({
         dt: [],
         default_conversion_rate: [],
         default_lb: [],
         default_ub: [],
         ezbot_conversion_rate: [],
         ezbot_lb: [],
         ezbot_ub: [],
      }),
   },
})

const showConfidenceIntervals = ref(false)
</script>

<style scoped lang="scss">
.graph-card {
   margin-top: 10px;
}
</style>
